// pages/FormViewerPage/sections/FormViewerLayout.tsx — Kerangka layout form per mode
import React from 'react';
import BrandFooter from '../../../components/BrandFooter';
import FormViewerBody from './FormViewerBody';
import type { FormViewerBodyProps } from './FormViewerBody/types';

export const FormViewerLayout: React.FC<{
    containerRef: any;
    isEmbed: boolean;
    isSimpleEmbed: boolean;
    isSeamless: boolean;
    brandId?: string;
    bodyProps: FormViewerBodyProps;
}> = ({ containerRef, isEmbed, isSimpleEmbed, isSeamless, brandId, bodyProps }) => {
    if (isSimpleEmbed) {
        return (
            <div ref={containerRef} className="w-full bg-transparent p-1 sm:p-2 overflow-hidden text-slate-900 dark:text-slate-100">
                <FormViewerBody {...bodyProps} isEmbed={isEmbed} isSimpleEmbed={true} />
            </div>
        );
    }

    return (
        <div className={isSeamless ? 'w-full bg-transparent' : 'min-h-screen flex justify-center bg-slate-100 dark:bg-slate-900'}>
            <div ref={isSeamless ? containerRef : undefined} className={isSeamless ? 'w-full bg-transparent overflow-hidden' : 'w-full max-w-[430px] min-h-screen shadow-2xl'}>
                <FormViewerBody {...bodyProps} isEmbed={isEmbed} isSimpleEmbed={false} isSeamless={isSeamless} />
                {!isEmbed && <BrandFooter brandId={brandId} />}
            </div>
        </div>
    );
};
